import router from "next/router";

import { logout } from "common/middleware/api.auth";

export const getAuthRedirectUrl = (
  options?: { refreshToken: boolean }
): string => {
  const { href } = window.location;
  const { query } = router;

  const redirectQuery = `redirect=${encodeURIComponent(href)}`;

  let url = `${process.env.NEXT_PUBLIC_AUTH_URL}/redirect?${redirectQuery}`;

  if (options?.refreshToken) {
    url = `${url}&action=refresh`;
  }

  if (query.email || query.leadEmail) {
    url = `${url}&email=${encodeURIComponent(query.email as string || query.leadEmail as string)}`;
  }

  return url;
}

export const logoutAndRedirect = () => {
  logout();
  window.location.href = `${process.env.NEXT_PUBLIC_AUTH_URL}/sign-out`;
}
